export default {
      id: "map__car_type_fire-fighter-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_fire-fighter",
      toString: function () {
        return this.url;
      }
    }